import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class IntraOne_ds_get_pick_tasks_by_shipping_container_idService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { task_id?: number, expected_shipping_container_id: number }): 
  Promise<{ result: { Id?: number, ExpectedPackagedAmount?: number, ExpectedPackagedPackId?: number, ExpectedSourceLocationId?: number, ExpectedTargetShippingContainerId?: number, Material?: { Id?: number, LookupCode?: string }, Shipment?: { ActualWarehouseId?: number, ExpectedWarehouseId?: number }, ExpectedTargetShippingContainer?: { Id?: number, LookupCode?: string }, Lot?: { Id?: number, VendorLot?: { Id?: number, ExpirationDate?: string, ManufactureDate?: string } }, primary_pick_location?: { id?: number, name?: string } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.expected_shipping_container_id)) {
      $missingRequiredInParams.push('\'expected_shipping_container_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/IntraOne/datasources/ds_get_pick_tasks_by_shipping_container_id/get`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { task_id?: number, expected_shipping_container_id: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, ExpectedPackagedAmount?: number, ExpectedPackagedPackId?: number, ExpectedSourceLocationId?: number, ExpectedTargetShippingContainerId?: number, Material?: { Id?: number, LookupCode?: string }, Shipment?: { ActualWarehouseId?: number, ExpectedWarehouseId?: number }, ExpectedTargetShippingContainer?: { Id?: number, LookupCode?: string }, Lot?: { Id?: number, VendorLot?: { Id?: number, ExpirationDate?: string, ManufactureDate?: string } }, primary_pick_location?: { id?: number, name?: string } }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.expected_shipping_container_id)) {
      $missingRequiredInParams.push('\'expected_shipping_container_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/IntraOne/datasources/ds_get_pick_tasks_by_shipping_container_id/getList`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { task_id?: number, expected_shipping_container_id: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, ExpectedPackagedAmount?: number, ExpectedPackagedPackId?: number, ExpectedSourceLocationId?: number, ExpectedTargetShippingContainerId?: number, Material?: { Id?: number, LookupCode?: string }, Shipment?: { ActualWarehouseId?: number, ExpectedWarehouseId?: number }, ExpectedTargetShippingContainer?: { Id?: number, LookupCode?: string }, Lot?: { Id?: number, VendorLot?: { Id?: number, ExpirationDate?: string, ManufactureDate?: string } }, primary_pick_location?: { id?: number, name?: string } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.expected_shipping_container_id)) {
      $missingRequiredInParams.push('\'expected_shipping_container_id\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/IntraOne/datasources/ds_get_pick_tasks_by_shipping_container_id/getByKeys`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      task_id?: number, expected_shipping_container_id: number    }) {
        if(isNil($inParams.expected_shipping_container_id)) {
          return true; 
        }
      return false;
    }
}
